import type { RootState } from "@/app/store/type";
import { createSelector } from "@reduxjs/toolkit";
import type { ProjectType } from "./types";

export const selectAllProjects = (state: RootState) => state.siteData.data?.projects;

export const selectProjectById = (id: string) =>
    createSelector(
        [selectAllProjects],
        (projects) => projects?.find((p: ProjectType) => p.id === id)
    );
